import { useMediaQuery } from "@suraasa/placebo-ui-legacy"
import { useEffect } from "react"

type Props = {
  query: string
}
/**
 * This hooks hides the top navigation wherever its called
 * @usage useHideTopNavigation()
 */
const useHideTopNavigation = (props?: Props) => {
  const shouldHide = useMediaQuery(props?.query || "")

  useEffect(() => {
    if (props?.query && shouldHide)
      document.body.classList.add("hideTopNavigation")

    if (!props) document.body.classList.add("hideTopNavigation")

    return () => {
      document.body.classList.remove("hideTopNavigation")
    }
  }, [props, shouldHide])
}

export default useHideTopNavigation
